import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as detailReducer, REDUCER_NAME as DETAIL_REDUCER_NAME } from './detail'
import { reducer as scanFileReducer, REDUCER_NAME as SCAN_FILE_REDUCER } from './file-upload'
import { reducer as imageReducer, REDUCER_NAME as IMAGE_REDUCER_NAME } from './image'
import { reducer as searchReducer, REDUCER_NAME as SEARCH_REDUCER } from './search'
import { reducer as transferFiles, REDUCER_NAME as TRANSFER_FILES } from './transfer-drive-files'
import { reducer as taskWidgetReducer, REDUCER_NAME as TASK_WIDGET_REDUCER_NAME } from './task-widget'
import { reducer as cbctFileReducer, REDUCER_NAME as CBCT_FILE_REDUCER } from './cbct-file-upload'

const reducer = combineReducers({
    [DETAIL_REDUCER_NAME]: detailReducer,
    [SCAN_FILE_REDUCER]: scanFileReducer,
    [IMAGE_REDUCER_NAME]: imageReducer,
    [SEARCH_REDUCER]: searchReducer,
    [TRANSFER_FILES]: transferFiles,
    [TASK_WIDGET_REDUCER_NAME]: taskWidgetReducer,
    [CBCT_FILE_REDUCER]: cbctFileReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/customer/state/index.js